<template>
    <div class="vue-root">
        <div class="form_success bg-success" :class="{'d-none': this.sentSuccessfull !== true}">
            {{t('register.success')}}
        </div>
        <div class="form webform row" :class="{'d-none': this.sentSuccessfull === true }">
            <div class="form-item text field-float" :class="{ 'is-invalid':  errorData.user_company}" general-errors="">
                <div class="input-wrapper">
                    <input id="register_firma" v-model="formData.user_company" name="register_firma" :placeholder="t('register.company')" type="text">
                    <label for="register_firma">
                        <span class="origin">{{ t('register.company') }}<span class="mandatory">*</span></span>
                        <span v-if="errorData.company" class="error"></span>
                    </label>
                </div>
            </div>
            <div v-if="scenario==='partner'" class="form-item text field-float" :class="{ 'is-invalid':  errorDataPartner.user_debitorennummer}" general-errors="">
                <div class="input-wrapper">
                    <input id="register_debitorennummer" v-model="formData.user_debitorennummer" name="user_debitorennummer" :placeholder="t('register.debitorennumber')" type="text">
                    <label for="register_debitorennummer">
                        <span class="origin">{{ t('register.debitorennumber') }}<span class="mandatory">*</span></span>
                        <span v-if="errorDataPartner.user_debitorennummer" class="error"></span>
                    </label>
                </div>
            </div>

            <div class="form-item radio form-check custom--selection form-check-inline" general-errors="">
                <div class="radio-container radio-row">
                    <div class="radio-item">
                        <input type="radio" id="register_salutation_m" v-model="formData.salutation" name="register_salutation" value="m">
                        <label for="register_salutation_m"> {{t('register.man')}} </label>
                    </div>
                    <div class="radio-item">
                        <input type="radio" id="register_salutation_f" v-model="formData.salutation" name="register_salutation" value="f">
                        <label for="register_salutation_f"> {{t('register.woman')}} </label>
                    </div>
                    <span v-if="errorData.salutation" class="error-text">{{t('register.required')}}</span>
                </div>
            </div>

            <div class="form-item text field-float col-50" :class="{ 'is-invalid':  errorData.firstname}" general-errors="">
                <div class="input-wrapper">
                    <input id="register_firstname" v-model="formData.firstname" name="register_firstname" :placeholder="t('register.firstname')" type="text">
                    <label for="register_firstname">
                        <span class="origin">{{ t('register.firstname') }}<span class="mandatory">*</span></span>
                        <span v-if="errorData.firstname" class="error"></span>
                    </label>
                </div>
            </div>

            <div class="form-item text field-float col-50" :class="{ 'is-invalid':  errorData.lastname}" general-errors="">
                <div class="input-wrapper">
                    <input id="register_lastname" v-model="formData.lastname" name="register_lastname" :placeholder="t('register.lastname')" type="text">
                    <label for="register_lastname">
                        <span class="origin">{{ t('register.lastname') }}<span class="mandatory">*</span></span>
                        <span v-if="errorData.lastname" class="error"></span>
                    </label>
                </div>
            </div>

            <div class="form-item text field-float col-100" :class="{ 'is-invalid':  errorDataArchitect.address}" general-errors="">
                <div class="input-wrapper">
                    <input id="register_address" v-model="formData.address" name="address" :placeholder="t('register.address')" type="text">
                    <label for="register_address">
                        <span class="origin">{{ t('register.address') }}<span class="mandatory">*</span></span>
                        <span v-if="errorDataArchitect.address" class="error"></span>
                    </label>
                </div>
            </div>

            <div v-if="scenario==='architect'" class="form-item text field-float col-50" :class="{ 'is-invalid':  errorData.address_additional}" general-errors="">
                <div class="input-wrapper">
                    <input id="register_address_additional" v-model="formData.address_additional" name="address_additional" :placeholder="t('register.address_additional')" type="text">
                    <label for="register_address_additional">
                        <span class="origin">{{ t('register.address_additional') }}<span class="mandatory">*</span></span>
                        <span v-if="errorData.address_additional" class="error"></span>
                    </label>
                </div>
            </div>

            <div class="form-item text field-float col-50" :class="{ 'is-invalid':  errorDataArchitect.zip}" general-errors="">
                <div class="input-wrapper">
                    <input id="register_zip" v-model="formData.zip" name="zip" :placeholder="t('register.zip')" type="text">
                    <label for="register_zip">
                        <span class="origin">{{ t('register.zip') }}<span class="mandatory">*</span></span>
                        <span v-if="errorDataArchitect.zip" class="error"></span>
                    </label>
                </div>
            </div>

            <div class="form-item text field-float col-50" :class="{ 'is-invalid':  errorDataArchitect.location}" general-errors="">
                <div class="input-wrapper">
                    <input id="register_location" v-model="formData.location" name="location" :placeholder="t('register.location')" type="text">
                    <label for="register_location">
                        <span class="origin">{{ t('register.location') }}<span class="mandatory">*</span></span>
                        <span v-if="errorDataArchitect.location" class="error"></span>
                    </label>
                </div>
            </div>


            <div class="form-item country field-float" :class="{ 'is-invalid':  errorDataArchitect.country}" general-errors="">
                <div class="form-item select field-float" :class="{ 'is-invalid':  errorDataArchitect.country}" general-errors="">
                    <div class="select__wrapper" :class="{ 'float-label': this.showOptionsCountryOpen }">
                        <button type="button" class="select" @click="toggleCountryOptions">
                            <span> {{ this.selectedOptionCountryLabelLabel }}</span>
                        </button>

                        <div v-if="showOptionsCountry" class="select__options">
                            <ul>
                                <template v-for="country in countries">
                                <li @click="setOptionCountry" :data-id="country.value" :data-label="country.label">
                                    {{country.label}}
                                </li>
                                </template>
                            </ul>
                        </div>

                        <i class="icon-form-arrow"/>
                    </div>
                    <label for="register_firmtype">
                        <span class="origin">{{t('register.country')}}<span class="mandatory">*</span></span>
                    </label>
                    <input type="hidden" name="user_companytype"/>
            </div>


            </div>


            <div v-if="scenario==='partner'"  class="form-item text field-float col-50" :class="{ 'is-invalid':  errorData.user_abteilung}" general-errors="">
                <div class="input-wrapper">
                    <input id="user_abteilung" v-model="formData.user_abteilung" name="register_user_abteilung" :placeholder="t('register.user_abteilung')" type="text">
                    <label for="user_abteilung">
                        <span class="origin">{{ t('register.user_abteilung') }}</span>
                        <span v-if="errorData.user_abteilung" class="error"></span>
                    </label>
                </div>
            </div>

            <div class="form-item text field-float" :class="{ 'is-invalid':  errorData.phone, 'col-50': scenario==='partner' }" general-errors="">
                <div class="input-wrapper">
                    <input id="register_phone" v-model="formData.phone" name="register_phone" :placeholder="t('register.phone')" type="text">
                    <label for="register_phone">
                        <span class="origin">{{ t('register.phone') }}<span class="mandatory">*</span></span>
                        <span v-if="errorData.phone" class="error"></span>
                    </label>
                </div>
            </div>

            <div class="form-item email field-float" :class="{ 'is-invalid':  errorData.email}" general-errors="">
                <div class="input-wrapper">
                    <input id="register_email" v-model="formData.email" name="register_email" :placeholder="t('register.email')" type="email">
                    <label for="register_email">
                        <span class="origin">{{ t('register.email') }}<span class="mandatory">*</span></span>
                        <span v-if="errorData.email" class="error">
                        </span>
                    </label>
                </div>
            </div>

            <div class="form-item password field-float" :class="{ 'is-invalid':  errorData.password}" general-errors="">
                <div class="input-wrapper">
                    <input id="password" v-model="formData.password" name="register_password" :placeholder="t('register.password')" type="password">
                    <label for="password">
                        <span class="origin">{{ t('register.password') }}<span class="mandatory">*</span></span>
                        <span v-if="errorData.password" class="error"></span>
                    </label>
                </div>
            </div>

            <div class="form-item password_repeat field-float" :class="{ 'is-invalid':  errorData.password_repeat}" general-errors="">
                <div class="input-wrapper">
                    <input id="password_repeat" v-model="formData.password_repeat" name="password_repeat" :placeholder="t('register.password_repeat')" type="password">
                    <label for="password_repeat">
                        <span class="origin">{{ t('register.password_repeat') }}<span class="mandatory">*</span></span>
                        <span v-if="errorData.password_repeat" class="error"></span>
                    </label>
                </div>
            </div>

            <div class="form-item agb" :class="{ 'is-invalid':  errorData.ads_agb}" general-errors="">
                <div class="form-item form-check custom--selection form-check-inline">
                    <input id="register_ads_agb" v-model="formData.ads_agb" name="register_ads_agb" :placeholder="t('register.ads_agb')" type="checkbox">
                    <label for="register_ads_agb">
                        <span class="origin">{{ t('register.ads_agb') }}<span class="mandatory">*</span></span>
                    </label>
                </div>
                <span v-if="errorData.ads_agb" class="error-text">{{t('register.required')}}</span>
            </div>

            <div v-if="errorMessage != ''">
                <span v-html="errorMessage"></span>
            </div>
            <div class="form-item button ml-auto mr-0 mt-2" general-errors="" values="" form-values="">
                <button type="submit" class="btn btn-primary" @click="registerUser()">
                    <span>{{ t('register.action') }}</span>
                </button>
            </div>
        </div>
        <div v-if="sentSuccessfull" class="pt-5">
            <a :href="this.slug"><button class="btn-primary">{{t('register.gohome')}}</button></a>
        </div>
    </div>
</template>
<script>
import gql from 'fake-tag';
import { FireI18n } from 'fire-js-i18n';
export default {
    name: 'RegisterForm',
    props: {
        slug: '',
        countries: {}
    },
    components: {},
    data: () => ({
        selectedOption: '',
        selectedOptionLabel: '',
        selectedOptionCountryLabel: '',
        showOptions: false,
        showOptionsCountry: false,
        showOptionsCountryOpen: false,
        scenario: '',
        formData: {
            'firstname': '',
            'lastname': '',
            'user_company': '',
            // 'user_companytype': '',
            'salutation': '',
            'email': '',
            // 'user_abteilung': '',
            'phone': '',
            // 'user_debitorennummer': '',
            'address': '',
            'address_additional': '',
            'zip': '',
            'country': '',
            'location': '',
            // 'contactpartner': '',
            'password': '',
            'password_repeat': '',
            'ads_agb': ''
        },
        errorData: {
            'firstname': false,
            'lastname': false,
            'salutation': false,
            'phone': false,
            'user_company': false,
            // 'user_companytype': false,
            'email': false,
            'password': false,
            'password_repeat': false,
            'ads_agb': false
        },
        errorDataArchitect: {
            'address': false,
            'zip': false,
            'location': false,
            'country': false
        },
        errorDataPartner: {
            // 'user_debitorennummer': false
        },
        sentSuccessfull: false,
        errorMessage: ''

    }),
    computed: {},
    watch: {},
    methods: {
        setOption(answer) {
            this.selectedOption = answer;
            this.formData.user_companytype = answer;
            switch(answer) {
                case 'partner':
                    this.selectedOptionLabel = this.t('register.partner');
                    this.scenario = 'partner';
                    break;
                case 'architect':
                    this.selectedOptionLabel = this.t('register.architect');
                    this.scenario = 'architect';
                    break;
            }
            this.showOptions = false;
        },
        setOptionCountry(event) {
            const itemValue = event.target.dataset.id;
            const itemLabel = event.target.dataset.label;
            this.formData.country = itemValue;
            this.selectedOptionCountryLabelLabel = itemLabel;
            this.showOptionsCountry = false;
        },
        toggleOptions() {
            this.showOptions = !this.showOptions;
        },
        toggleCountryOptions() {
            this.showOptionsCountry = !this.showOptionsCountry;
            this.showOptionsCountryOpen = true;
        },
        onClickOutside() {
            this.showOptions = false;
            this.showOptionsCountry = false;
        },

        validateData(inputdataObj, errorObj, errorObjScenario) {
            let valid = true;
            Object.keys(inputdataObj).forEach(key =>
            {
                console.log(key);
                if(inputdataObj[key] == '' && errorObj.hasOwnProperty(key))
                {
                    errorObj[key] = true;
                    valid = false;
                }
                if(key == 'email')
                {
                    const re = /[a-zA-Z0-9\._%+-]+@[a-zA-Z0-9\.-]+\.[a-zA-Z]{2,}/;
                    if (!inputdataObj[key] || !re.test(inputdataObj[key])) {
                        errorObj[key] = true;
                        valid = false;
                    }
                }
                if(key == 'password_repeat')
                {
                    errorObj[key] = (inputdataObj.password !== inputdataObj.password_repeat)
                }
            });
            Object.keys(errorObjScenario).forEach(key =>
            {
                if(inputdataObj[key] == '' && errorObjScenario.hasOwnProperty(key))
                {
                    errorObjScenario[key] = true;
                    valid = false;
                }
            });
            return valid;
        },
        registerUser() {
          let valid = false;
          valid = this.validateData(this.formData, this.errorData, this.errorDataArchitect);
          let frontenduserGeneral = {
            username: this.formData.email,
            email: this.formData.email,
            firstname: this.formData.firstname,
            lastname: this.formData.lastname,
            salutation: this.formData.salutation,
            user_address: this.formData.address,
            user_zip: this.formData.zip,
            user_location: this.formData.location,
            user_country: this.formData.country,
            phone: this.formData.phone,
            user_company: this.formData.user_company,
            password: this.formData.password,
            password_repeat: this.formData.password_repeat,
            user_companytype: 'architect', //always architect
            ads_agb: (this.formData.ads_agb) ? '1' : '0'
          }
          if (valid) {
            this.sendForm(frontenduserGeneral)
          }


        },
        sendForm(frontenduserData) {
          console.log(frontenduserData)
            let body = {
                    query: gql`
                    mutation registerFrontendUser ($frontenduserData: FrontenduserInputType){
                        registerFrontenduser(frontenduserData: $frontenduserData) {
                            id
                            firstname
                            email
                            errors
                            modelErrors {
                                attribute
                                className
                                errors
                            }
                        }
                    }`
                    ,
                    variables: {
                        frontenduserData
                    }
                };
                fetch(graphqlApi, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-Token": yii.getCsrfToken(),
                    },
                    body: JSON.stringify(body),
                })
                    .then((res) => res.json())
                    .then((res) =>
                    {
                        console.log(res);
                        let msg = '';
                        let nl = '<br />';
                        if (!res.data.registerFrontenduser.errors) {
                            this.sentSuccessfull = true;
                            this.errorMessage = '';
                        }
                        if (res.data.registerFrontenduser.modelErrors) {
                            let errorObj = res.data.registerFrontenduser.modelErrors;
                            Object.keys(errorObj).forEach(line => {
                                if (errorObj[line].attribute == 'email')
                                {
                                    msg += errorObj[line].errors[0] + nl;
                                }
                                if (errorObj[line].attribute == 'password')
                                {
                                    msg += errorObj[line].errors[0] + nl;
                                }
                                if (errorObj[line].attribute == 'password_repeat')
                                {
                                    msg += errorObj[line].errors[0] + nl;
                                }
                            })
                        }
                        console.log(msg);
                        this.errorMessage = msg;
                    });
        },
        t(key, options) {
            return FireI18n.t(key, options);
        }
    },
    mounted()
    {
        this.selectedOptionLabel = this.t('register.companytypeinit');
        this.selectedOptionCountryLabelLabel = this.t('register.country');
    }
}
</script>

<style lang="scss">
.register_container {
  .webform {
    justify-content: space-between;
  }
}
</style>